import axios from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import showToast from "../components/Toast";
import { setSession } from "../session";

export const login = async (credentials) => {
  const response = await axios.post("/api/v1/user/login", credentials);
  return response.data.data;
};

export const useLogin = () => {
  const navigate = useNavigate();

  return useMutation(login, {
    onSuccess: (session) => {
      // Non-admins are refused here rather than after the redirect, so the
      // reason is visible at the point of failure.
      if (session.role !== "admin") {
        showToast("That account isn't an administrator.", "error");
        return;
      }

      setSession(session);
      navigate("/");
    },
    onError: (error) => {
      showToast(
        error.response?.data?.error || "Couldn't sign in. Check your details.",
        "error"
      );
    },
  });
};
